import React, { useEffect, useState } from "react";
import axios from "axios";
import { Link, useNavigate } from "react-router-dom";

export default function CollectionList() {
  const [categories, setCategories] = useState([]);
  const navigate = useNavigate();

  async function getCategories() {
    try {
      let { data } = await axios.get(
        `https://api.elza2.store/api/v1/categories`
      );
      setCategories(data.categories);
    } catch (error) {
      console.error("Error fetching categories:", error);
    }
  }

  useEffect(() => {
    getCategories();
  }, []);

  const handleCategoryClick = (category) => {
    if (category.subCategories.length > 0) {
      navigate(`/category/${category.slug}`, { state: { category } });
    } else {
      navigate(`/products?category=${category._id}`);
    }
  };

  return (
    <section>
      <div className="text-main mb-5 px-5 text-3xl font-bold ml-3">
        Collection List
      </div>

      <div className="grid px-5 sm:m-5 grid-cols-2 md:grid-cols-3 lg:grid-cols-5 sm:grid-cols-6 gap-4">
        {categories.map((category) => (
          <div
            key={category._id}
            onClick={() => handleCategoryClick(category)}
            className="max-w-sm cursor-pointer transform hover:scale-105 transition-transform duration-300"
          >
            <img
              src={category.image}
              alt={`${category.name} Preview`}
              className="rounded-lg"
            />
            <div className="text-center mt-2 font-semibold">
              {category.name}
              {category.subCategories.length > 0 && (
                <span className="text-sm text-gray-500 ml-2">
                  (+{category.subCategories.length})
                </span>
              )}
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
